import { render, staticRenderFns } from "./ImgShowroomTable.vue?vue&type=template&id=55e70e00&scoped=true&"
import script from "./ImgShowroomTable.vue?vue&type=script&lang=js&"
export * from "./ImgShowroomTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e70e00",
  null
  
)

export default component.exports